<txtb-drawer
  #drawerComponent
  [groupInfo]="groupInfo"
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [zoomFeatureAvailable]="true"
  (actionDrawerApiInitialized)="onActionDrawerApiInitialized($event)"
>
  <ng-container main>
    <article
      [class.exercise]="!(drawerComponent?.drawingByPointerMove$ | async)"
      [class.active]="drawerComponent?.drawingByPointerMove$ | async"
    >
      <txtb-image-wrapper
        class="question-image"
        *ngIf="(currentQuestion$ | async)?.resourceId as questionResourceId"
        [imgSrc]="imagesByResourceIdMap[questionResourceId]"
        [src]="imagesByResourceIdMap[questionResourceId]"
        [imagesScalingEnabled]="(scalingEnabled$ | async) === true"
        [percentageScale]="(currentQuestion$ | async)?.percentageScale || null"
        [scalingDirection]="ImageScalingToWidth"
      ></txtb-image-wrapper>
      <div #wrapper class="wrapper" *ngIf="(indexToOrderMapping$ | async) as indexToOrderMapping"
           [style.--direction]="((rows$ | async) || 0 ) > 1 ? 'row' : 'column'"
           [style.--img-container-width]="(answerWidthPercent$ | async) + '%'"
           [style.--answer-button-space-percent]="(answerButtonSpacePercent$ | async) + '%'"
           [style.--answer-padding-percent]="ANSWER_PADDING_PERCENT + '%'">
        <ng-container
          *ngFor="
            let item of (currentExerciseSubitems$ | async);
            let i = index;
            trackBy: trackByAnswerItem
          "
        >
          <div class="items" [style.--width]="(answerWidthPercent$ | async) + '%'"
               [style.order]="indexToOrderMapping[i] || i">
            <button type="button"
                    class="answer-button"
                    [class.scaled-btn]="(scalingEnabled$ | async) === true"
                    [disabled]="(userAnswersCorrectnessState$ | async)?.[(currentExerciseIndex$ | async) || 0] === true"
                    [class.is-marked]="(currentExerciseUserAnswers$ | async)?.[i] === true"
                    [class.is-correct-button]="(userAnswersCorrectnessState$ | async)?.[(currentExerciseIndex$ | async) || 0] === true && (currentExerciseUserAnswers$ | async)?.[i] === true"
                    [class.is-wrong-button]="!isFixMode && (userAnswersCorrectnessState$ | async)?.[(currentExerciseIndex$ | async) || 0] === false && (currentExerciseUserAnswers$ | async)?.[i] === true"
                    (click)="setAnswer(i)">
              <svg class="answer-btn-label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <g transform="translate(8,8)">
                  <text x="0%" y="0%" text-anchor="middle"
                        dominant-baseline="central">{{ (10 + i).toString(36).toUpperCase() }}
                  </text>
                </g>
              </svg>
            </button>
            <txtb-image-wrapper
              style="width: 100%"
              class="answer-image"
              [class.scaled]="!!item.answer.percentageScale && (scalingEnabled$ | async) === true"
              [fixRender]="false"
              [center]="false"
              [imgSrc]="imagesByResourceIdMap[item.answer.resourceId]"
              [src]="imagesByResourceIdMap[item.answer.resourceId]"
              [imagesScalingEnabled]="(scalingEnabled$ | async) === true"
              [percentageScale]="item.answer.percentageScale"
              [scalingDirection]="ImageScalingToWidth"
            ></txtb-image-wrapper>
          </div>
        </ng-container>
      </div>
    </article>
  </ng-container>

  <section footer class="bottom-ui">
    <div class="controls">
      <div class="pagination" *ngFor="let item of (shuffledExerciseItems$ | async); let i = index">
        <button
          *ngIf="((shuffledExerciseItemsLength$ | async) || 0) > 1"
          [id]="'self-check-exercise-change-question-btn-' + i"
          class="pagination-item"
          [class.is-selected]="(currentExerciseIndex$ | async) === i"
          [class.is-answer-selected-paginator]="isExerciseAnswerMarked(i)"
          [class.is-correct-answer-paginator]="(userAnswersCorrectnessState$ | async)?.[i] === true"
          [class.is-wrong-answer-paginator]="(userAnswersCorrectnessState$ | async)?.[i] === false"
          (click)="changeExercise(i)"
        >
          {{ i + 1 }}
        </button>
      </div>
    </div>
    <button
      id="self-check-exercise-check-answers-btn"
      class="check-button"
      [class.is-hidden]="!this.isButtonCheckReady"
      (click)="checkAnswers()"
    >
      {{ checkText }}
    </button>
  </section>
</txtb-drawer>

<div
  id="self-check-exercise-summary-modal"
  class="modal"
  [class.is-hidden]="this.modalOpened === false"
  (click)="fixAnswers()"
>
  <article class="modal-content">
    <section>
      {{
        'Liczba poprawnych odpowiedzi: ' + ((numberOfCorrectAnswers$ | async) || 0) + '/' + (shuffledExerciseItemsLength$ | async)
      }}
    </section>
    <section class="modal-button-ui">
      <button
        id="self-check-exercise-fix-answers-btn"
        class="fix-button"
        [class.is-visible]="((numberOfCorrectAnswers$ | async) || 0) === (shuffledExerciseItemsLength$ | async)"
        (click)="fixAnswers()"
      >
        {{ fixText }}
      </button>
      <button
        id="self-check-exercise-reset-answers-btn"
        class="reset-button"
        (click)="reset()"
      >
        {{ resetText }}
      </button>
    </section>
  </article>
</div>
